module.exports = __webpack_public_path__ + "static/img/list-bg.d449234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smashing-golden-eggs/list-bg.png
// module id = gv9q
// module chunks = 216